// The message sent to participants when an activity is cancelled automatically because its minimum
// number of participants was not reached (falcon-a activities-cron.js). The backend reads
// config/messagetemplates.cancellations[] and uses the FIRST entry with channel 'mail' and collection
// 'activities': its subject, plain-text body and optional replyto.
//
// Backend behaviour worth knowing (activities-cron.js:221-262):
// - no cancellations array at all (or an empty one) -> NO message is sent to participants;
// - an array without an activities entry -> a built-in default text is sent;
// - each {VARIABLE} is replaced only once per message (String.replace with a string).
// Keep this file free of React and Firebase.

export const isActivityCancellation = (t) => !!t && t.channel === 'mail' && t.collection === 'activities'

export const findActivityCancellation = (list) => (Array.isArray(list) ? list.find(isActivityCancellation) || null : null)

// A new cancellations array with the activities entry updated (or added). Other entries, and the
// entry's own other fields, are kept as they are.
export const upsertActivityCancellation = (list, changes) => {
  const current = Array.isArray(list) ? list : []
  const index = current.findIndex(isActivityCancellation)
  if (index === -1) return current.concat([{ channel: 'mail', collection: 'activities', ...changes }])
  return current.map((t, i) => (i === index ? { ...t, ...changes, channel: 'mail', collection: 'activities' } : t))
}

export const ACTIVITY_CANCELLATION_FIELDS = [
  { token: 'PERSON_NAME', description: 'Osallistujan etu- ja sukunimi' },
  { token: 'PERSON_FIRSTNAME', description: 'Osallistujan etunimi' },
  { token: 'PERSON_LASTNAME', description: 'Osallistujan sukunimi' },
  { token: 'ACTIVITY_NAME', description: 'Aktiviteetin nimi' },
  { token: 'ACTIVITY_DATETIME', description: 'Aktiviteetin alkamisaika (pp.kk.vvvv hh:mm)' },
]

// Same wording as the backend's built-in text, with the variables in place.
export const DEFAULT_ACTIVITY_CANCELLATION = {
  subject: 'Tapahtuma peruttu - {ACTIVITY_NAME}',
  body:
    'Hyvä {PERSON_FIRSTNAME},\n\n' +
    'Tapahtuma "{ACTIVITY_NAME}" ({ACTIVITY_DATETIME}) on valitettavasti peruttu, koska vähimmäisosallistujamäärä ei täyttynyt.\n\n' +
    'Mahdolliset maksut on hyvitetty saldollesi tai sarjakortillesi.\n\n' +
    'Kiitos ymmärryksestäsi.',
}

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export const validateActivityCancellation = ({ subject, body, replyto }) => {
  const errors = []
  if (!subject || !subject.trim()) errors.push('Otsikko puuttuu.')
  if (!body || !body.trim()) errors.push('Viestin teksti puuttuu.')
  if (replyto && replyto.trim() && !EMAIL.test(replyto.trim())) errors.push('Vastausosoite ei ole sähköpostiosoite.')
  return errors
}
